import { Badge } from '@zarya/ui';
import type { EstadoIdentidade } from './Identities.api';
import { STATE_TOM, stateLabel, stateTip } from './identityVocab';

export interface IdentityStateBadgeProps {
  state: EstadoIdentidade;
  /** `false` esconde a explicação ⓘ (útil dentro de tabelas densas). */
  tip?: boolean;
}

/** Badge do state exibido da identidade (FR-051) — rótulo, tom e explicação. */
export function IdentityStateBadge({ state, tip = true }: IdentityStateBadgeProps) {
  return (
    <Badge tone={STATE_TOM[state]} tip={tip ? stateTip(state) : undefined}>
      {stateLabel(state)}
    </Badge>
  );
}
